/* ============================================================================
   xa-top-fade.js — light scroll-triggered fade-in for the TOP page
   - Adds .xa-fade / .xa-fade-child to target elements after DOM ready
   - One IntersectionObserver tracks them; element is unobserved on first hit
   - Children of stagger groups get a per-index transition-delay for cascade
   - prefers-reduced-motion users skip animation entirely
============================================================================ */
(function () {
  'use strict';
  if (window.__xaTopFadeInit) return;
  window.__xaTopFadeInit = true;

  if (window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Single elements that fade as one block.
  var FADE_TARGETS = [
    '.xa-top-bold .tension__kicker',
    '.xa-top-bold .tension__title',
    '.xa-top-bold .tension__list',
    '.xa-top-bold .tension__conclusion',
    '.xa-top-bold .standard__head',
    '.xa-top-bold .standard__conclusion',
    '.xa-top-bold .bos__head',
    '.xa-top-bold .bos__cta',
    '.xa-top-bold .services__head',
    '.xa-top-bold .services__foot',
    '.xa-top-bold .alliance__brand',
    '.xa-top-bold .alliance__title',
    '.xa-top-bold .alliance__body',
    '.xa-top-bold .alliance__keywords',
    '.xa-top-bold .alliance__partners-label',
    '.xa-top-bold .cases__head',
    '.xa-top-bold .cases__tier2-label',
    '.xa-top-bold .insights__head',
    '.xa-top-bold .news__head',
    '.xa-top-bold .faq__head',
    '.xa-top-bold .contact-final__title',
    '.xa-top-bold .contact-final__lede',
    '.xa-top-bold .contact-final .btn'
  ];

  // Containers whose direct children fade in with a staggered delay.
  // stride is in milliseconds.
  var STAGGER_GROUPS = [
    { selector: '.xa-top-bold .standard__diagram',     stride: 100 },
    { selector: '.xa-top-bold .bos__layers',           stride: 70  },
    { selector: '.xa-top-bold .services-grid',         stride: 100 },
    { selector: '.xa-top-bold .alliance__partners-grid', stride: 30 },
    { selector: '.xa-top-bold .cases__grid',           stride: 100 },
    { selector: '.xa-top-bold .cases__tier2-grid',     stride: 50  },
    { selector: '.xa-top-bold .insights__grid',        stride: 100 },
    { selector: '.xa-top-bold .news__list',            stride: 60  },
    { selector: '.xa-top-bold .faq__list',             stride: 50  }
  ];

  function init() {
    var watched = [];

    // Single-block fade targets.
    FADE_TARGETS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.classList.add('xa-fade');
        watched.push(el);
      });
    });

    // Stagger groups: tag children with .xa-fade-child + per-index delay.
    STAGGER_GROUPS.forEach(function (group) {
      document.querySelectorAll(group.selector).forEach(function (parent) {
        var children = parent.children;
        for (var i = 0; i < children.length; i++) {
          var child = children[i];
          child.classList.add('xa-fade-child');
          child.style.transitionDelay = (i * group.stride) + 'ms';
          watched.push(child);
        }
      });
    });

    if (!('IntersectionObserver' in window) || watched.length === 0) {
      // Older browsers: just reveal everything immediately.
      watched.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.05
    });

    watched.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
